import React from "react"
import { MDBBtn, MDBIcon } from "mdbreact"

const RegisterForm = () => {
  return (
    <form>
      {/* <label htmlFor="defaultFormContactNameEx" className="grey-text">
        Your name
      </label> */}
      <input
        type="text"
        id="defaultFormContactNameEx"
        className="form-control"
        placeholder="Name"
      />
      <br />
      {/* <label htmlFor="defaultFormContactEmailEx" className="grey-text">
        Your email
      </label> */}
      <input
        type="email"
        id="defaultFormContactEmailEx"
        className="form-control"
        placeholder="Email"
      />
      <br />
      {/* <label htmlFor="defaultFormContactSubjectEx" className="grey-text">
        Subject
      </label> */}
      <input
        type="text"
        id="defaultFormContactPhoneEx"
        className="form-control"
        placeholder="Phone"
      />
      <br />
      {/* <label htmlFor="defaultFormContactMessageEx" className="grey-text">
        Your message
      </label> */}
      <textarea
        type="text"
        id="defaultFormContactMessageEx"
        className="form-control"
        placeholder="Message"
        rows="3"
      />
      <div className="text-center mt-4">
        <MDBBtn color="orange" href="#">
          <MDBIcon icon="paper-plane" className="mr-2" />
          Sign Up Now!
        </MDBBtn>
      </div>
    </form>
  )
}

export default RegisterForm
